import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map'
import { GETCMLIST} from 'src/app/components/Shared/Model/GETCMLIST'


@Injectable()
export class FxcrsD_UService {

    constructor(
        private http: HttpClient,
    ) { }

      // private baseEndPoint: string = "http://localhost:52867/"
    //private baseEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/" 
    //private baseEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/"
     private baseEndPoint: string = "https://fxdhdashboardapi.idsnext.live/"
    //private baseEndPoint: string = "https://idsdatahubdashboardapinew.azurewebsites.net/" 


    getSkyBookD(PMSCUSTCODE: any,fromDate:any,ToDate:any,PGF:any,PGT:any,Source:any,Search:any)
    {
       
    let data = { 'PmsCode': PMSCUSTCODE,'From':fromDate,'To':ToDate,
    'PaginationFromId':PGF,'PaginationToId':PGT,'loginid':Source,'Search':Search};
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
        
       
          
          let endPoint = this.baseEndPoint + "api/FxcrsDw_Up/IsFxcrsDw_Up";
        return this.http.post(endPoint,  data , { headers: headers })
          .map((response: Response) => JSON.parse(JSON.stringify(response)));
     }

     getSkyBookU(PMSCUSTCODE: any,fromDate:any,ToDate:any,PGF:any,PGT:any,Source:any,Search:any)
     {
        
     let data = { 'PmsCode': PMSCUSTCODE,'From':fromDate,'To':ToDate,
     'PaginationFromId':PGF,'PaginationToId':PGT,'loginid':Source,'Search':Search};
         let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
         
        
           
           let endPoint = this.baseEndPoint + "api/FxcrsDw_Up/IsFxcrsDw_Upload";
         return this.http.post(endPoint,  data , { headers: headers })
           .map((response: Response) => JSON.parse(JSON.stringify(response)));
      }

      getRateInputLog(PMSCUSTCODE: any,fromDate:any,ToDate:any,PGF:any,PGT:any,Source:any,Search:any)
    {
       
    let data = { 'PmsCode': PMSCUSTCODE,'From':fromDate,'To':ToDate,
    'PaginationFromId':PGF,'PaginationToId':PGT,'loginid':Source,'Search':Search};
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
        
       
          
          let endPoint = this.baseEndPoint + "api/FxcrsRateLog/GetRateInputLog";
        return this.http.post(endPoint,  data , { headers: headers })
          .map((response: Response) => JSON.parse(JSON.stringify(response)));
     }

     getSkyXML(Xchangeformat: any)
     {
        
     let data = { 'xchangeformat': Xchangeformat};
         let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
         
        
           
           let endPoint = this.baseEndPoint + "api/FxcrsDw_Up/IsFxcrsDw_UpXML";
         return this.http.post(endPoint,  data , { headers: headers })
           .map((response: Response) => JSON.parse(JSON.stringify(response)));
      }
      getSkyXMLU(Xchangeformat: any)
      {
         
      let data = { 'token': Xchangeformat};
          let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
          
         
            
            let endPoint = this.baseEndPoint + "api/FxcrsInv/IsFxcrsUXml";
          return this.http.post(endPoint,  data , { headers: headers })
            .map((response: Response) => JSON.parse(JSON.stringify(response)));
       }

       getSkyXMLUBook(Xchangeformat: any)
       {
          
       let data = { 'token': Xchangeformat};
           let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
           
          
             
             let endPoint = this.baseEndPoint + "api/FxcrsInv/IsFxcrsUBookXml";
           return this.http.post(endPoint,  data , { headers: headers })
             .map((response: Response) => JSON.parse(JSON.stringify(response)));
        }

    }